module.exports = __webpack_public_path__ + "img/DNARepair-GBM_SPATA.80856c3c.png";